import { PoisTilesetService } from '@workspaces/services'
import { Environment, Metadata, SharedPlan } from '@workspaces/types'
import SharedPlanService from './sharedPlan.service'

async function genericCallToGetMappingIds(
  meta: Metadata.AppMetadata,
  environment: Environment.EnvironmentResolver,
  action: SharedPlan.Action,
  values: string[],
): Promise<number[]> {
  let ids: number[] = []
  if (values.length === 0) {
    return ids
  }

  const isSharedPlan = environment.isSharePlan().sharing
  if (isSharedPlan) {
    // The values MUST reach the cloud function: without them it resolves ids
    // for every value in the plan's filters, and per-selection callers (the
    // POI logos cache) would get the union — selections of the same
    // classification would then overwrite each other's icon (sc-563940).
    ids = await SharedPlanService.genericCallToCloudFunction<number[]>(
      meta,
      environment,
      action,
      false,
      values,
    )
  } else {
    switch (action) {
      case SharedPlan.Action.MappingPOIsBrands:
        ids = await PoisTilesetService.getIdsForBrands(
          meta,
          environment,
          values,
        )
        break
      case SharedPlan.Action.MappingPOIsTags:
        ids = await PoisTilesetService.getIdsForTags(meta, environment, values)
        break
      case SharedPlan.Action.MappingPOIsTopCategories:
        ids = await PoisTilesetService.getIdsForTopCategories(
          meta,
          environment,
          values,
        )
        break
      case SharedPlan.Action.MappingPOIsSubCategories:
        ids = await PoisTilesetService.getIdsForSubCategories(
          meta,
          environment,
          values,
        )
        break
      default:
        throw new Error(`Unknown action ${action}`)
    }
  }
  return ids
}

export async function getIdsForBrands(
  meta: Metadata.AppMetadata,
  environment: Environment.EnvironmentResolver,
  brands: string[],
): Promise<number[]> {
  const ids = await genericCallToGetMappingIds(
    meta,
    environment,
    SharedPlan.Action.MappingPOIsBrands,
    brands,
  )
  return ids
}

export async function getIdsForTags(
  meta: Metadata.AppMetadata,
  environment: Environment.EnvironmentResolver,
  tags: string[],
): Promise<number[]> {
  const ids = await genericCallToGetMappingIds(
    meta,
    environment,
    SharedPlan.Action.MappingPOIsTags,
    tags,
  )
  return ids
}

export async function getIdsForTopCategories(
  meta: Metadata.AppMetadata,
  environment: Environment.EnvironmentResolver,
  topCategories: string[],
): Promise<number[]> {
  const ids = await genericCallToGetMappingIds(
    meta,
    environment,
    SharedPlan.Action.MappingPOIsTopCategories,
    topCategories,
  )
  return ids
}

export async function getIdsForSubCategories(
  meta: Metadata.AppMetadata,
  environment: Environment.EnvironmentResolver,
  subCategories: string[],
): Promise<number[]> {
  const ids = await genericCallToGetMappingIds(
    meta,
    environment,
    SharedPlan.Action.MappingPOIsSubCategories,
    subCategories,
  )
  return ids
}
